export const ARIA_PREFIX = 'aria';
export const ATTR_PREFIX = 'attr';
export const DATA_PREFIX = 'data';
export const HOOK_PREFIX = 'hook';
export const EVENT_PREFIX = 'on';

export const MODULES = [
	'hook',
	'ref',
	'now-aria-ref',
	'on',
	'style',
	'class',
	'attrs',
	'props',
	'dataset'
];

export const ACRONYM_PROPS = ['innerHTML', 'outerHTML'];
export const DEPRECATED_HTML_ACRONYM_PROPS = ['innerHTML', 'outerHTML'];
export const DEPRECATED_HTML_ACRONYM_PROPS_MAP = {
	innerHTML: 'dangerouslySetInnerHTML',
	outerHTML: 'dangerouslySetOuterHTML'
};
export const DANGEROUS_HTML_ACRONYM_PROPS_MAP = {
	dangerouslySetInnerHTML: 'innerHTML',
	dangerouslySetOuterHTML: 'outerHTML'
};

export const APPEND_TO_PAYLOAD = 'append-to-payload';
export const APPEND_TO_META = 'append-to-meta';

export const BASE_ATTRIBUTES = [
	'path',
	'context',
	'context-modifier',
	'key',
	'alt',
	'async',
	'autocomplete',
	'autofocus',
	'autoplay',
	'capture',
	'checked',
	'default',
	'defer',
	'disabled',
	'draggable',
	'dropzone',
	'hidden',
	'href',
	'hreflang',
	'http-equiv',
	'icon',
	'id',
	'is',
	'maxlength',
	'minlength',
	'media',
	'method',
	'multiple',
	'name',
	'placeholder',
	'readonly',
	'rel',
	'required',
	'reversed',
	'role',
	'rows',
	'rowspan',
	'selected',
	'slot',
	'src',
	'tabindex',
	'target',
	'title',
	'type',
	'value'
];

export const CUSTOM_ELEMENT_ATTRIBUTES = [
	...BASE_ATTRIBUTES,
	'component-id',
	'listen-to',
	'dangerouslySetInnerHTML',
	'dangerouslySetOuterHTML',
	'suppressContentEditableWarning',
	'suppressHydrationWarning'
];

export const NON_CUSTOM_ELEMENT_ATTRIBUTES = [
	...BASE_ATTRIBUTES,
	'accept',
	'accept-charset',
	'accesskey',
	'action',
	'align',
	'allow',
	'autocapitalize',
	'background',
	'bgcolor',
	'border',
	'buffered',
	'challenge',
	'charset',
	'cite',
	'code',
	'codebase',
	'color',
	'cols',
	'colspan',
	'content',
	'contenteditable',
	'contextmenu',
	'controls',
	'coords',
	'crossorigin',
	'datetime',
	'decoding',
	'dir',
	'dirname',
	'download',
	'enctype',
	'for',
	'form',
	'formaction',
	'formenctype',
	'formmethod',
	'formnovalidate',
	'formtarget',
	'headers',
	'height',
	'high',
	'integrity',
	'intrinsicsize',
	'inputmode',
	'ismap',
	'itemprop',
	'keytype',
	'kind',
	'label',
	'lang',
	'language',
	'list',
	'loop',
	'low',
	'manifest',
	'max',
	'min',
	'muted',
	'novalidate',
	'open',
	'optimum',
	'pattern',
	'ping',
	'poster',
	'preload',
	'radiogroup',
	'referrerpolicy',
	'sandbox',
	'scope',
	'scoped',
	'shape',
	'size',
	'sizes',
	'span',
	'spellcheck',
	'srcdoc',
	'srclang',
	'srcset',
	'start',
	'step',
	'summary',
	'translate',
	'usemap',
	'width',
	'wrap'
];
